import { render, staticRenderFns } from "./ImportRequest.vue?vue&type=template&id=0971573c&"
import script from "./ImportRequest.vue?vue&type=script&lang=js&"
export * from "./ImportRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports